import {RECEIVE_PENDING_PERIODICALS,RECEIVE_SCHEDULE_PERIODICALS,PENDING_SCHEDULE_PERIODICALS_UPDATE,SCHEDULE_PERIODICALS_UPDATE,DRAG_TO_MONTH
   } from 'shared/actions/scheduling_action';

   function schedulingReducer(state = {pending_periodicals_data:[],schedule_periodicals_data:[],pending_periodicals_update:[],schedule_periodicals_update:[]}, action) {
    switch (action.type) {
      case RECEIVE_PENDING_PERIODICALS:
        return Object.assign({}, state, {
            pending_periodicals_data: action.pending_periodicals_data
        })

        case RECEIVE_SCHEDULE_PERIODICALS:
        return Object.assign({}, state, {
          schedule_periodicals_data: action.schedule_periodicals_data
        })

        case PENDING_SCHEDULE_PERIODICALS_UPDATE:
        return Object.assign({}, state, {
          pending_periodicals_update: action.pending_periodicals_update
        })

        case SCHEDULE_PERIODICALS_UPDATE:
        return Object.assign({}, state, {
          schedule_periodicals_update: action.schedule_periodicals_update
        })
        case DRAG_TO_MONTH:
        return Object.assign({}, state, {
          schedule_periodicals_update: action.schedule_periodicals_update
        })

        default:
      return state
    }
}

export default schedulingReducer;


// WEBPACK FOOTER //
// ./src/shared/reducers/scheduling_reducer.js